import { useEffect } from 'react'

import { sendAnalyticsEvent } from 'services/analytics'

import { EVENT_TYPE } from 'resources'
import { STRING } from 'resources/string'

import { Container, Title, Description } from './styles'

const NoInternetConnection = () => {
  useEffect(() => {
    sendAnalyticsEvent(EVENT_TYPE.noNetworkAccessView)
  }, [])

  return (
    <Container>
      <Title>{STRING.networkError.noInternetConnection.title}</Title>
      <Description>{STRING.networkError.noInternetConnection.description}</Description>
    </Container>
  )
}

export default NoInternetConnection
